<template>
  <div class="chat-msg" :class="`chat-msg--${message.role}`">
    <div class="chat-msg__bubble">
      <div v-if="message.role === 'assistant'" v-html="html"></div>
      <span v-else>{{ message.content }}</span>
    </div>
    <ChatPropertyCards
      v-if="message.properties && message.properties.length"
      :properties="message.properties"
    />
    <div class="chat-msg__replies" v-if="showReplies">
      <button
        type="button"
        class="chat-msg__reply"
        v-for="option in message.quickReplies"
        :key="option"
        @click="pick(option)"
      >{{ option }}</button>
    </div>
  </div>
</template>

<script>
import { renderMarkdown } from '../../utils/markdown'
import ChatPropertyCards from './ChatPropertyCards.vue'

export default {
  name: 'ChatMessage',
  components: { ChatPropertyCards },
  props: {
    message: { type: Object, required: true },
    // Los botones son la respuesta a la última pregunta: en los mensajes
    // anteriores ya no vienen a cuento y se dejan de pintar.
    isLast: { type: Boolean, default: false }
  },
  computed: {
    html () {
      return renderMarkdown(this.message.content)
    },
    showReplies () {
      return (
        this.isLast &&
        this.message.role === 'assistant' &&
        !!(this.message.quickReplies && this.message.quickReplies.length) &&
        !this.$store.state.chat.isLoading
      )
    }
  },
  methods: {
    pick (option) {
      this.$store.dispatch('chat/send', option)
    }
  }
}
</script>

<style scoped>
.chat-msg {
  margin-bottom: 14px;
}
.chat-msg__bubble {
  display: inline-block;
  max-width: 88%;
  padding: 10px 14px;
  border-radius: 16px;
  line-height: 1.5;
  font-size: 15px;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.chat-msg--user {
  text-align: right;
}
.chat-msg--user .chat-msg__bubble {
  background: #E45726;
  color: #fff;
  border-bottom-right-radius: 4px;
  text-align: left;
}
.chat-msg--assistant .chat-msg__bubble {
  background: #F1F3F5;
  color: #1D262D;
  border-bottom-left-radius: 4px;
}
.chat-msg__replies {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.chat-msg__reply {
  background: #fff;
  border: 1px solid #E45726;
  border-radius: 999px;
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 600;
  color: #E45726;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.chat-msg__reply:hover {
  background: #E45726;
  color: #fff;
}
.chat-msg--error .chat-msg__bubble {
  background: #FDECEA;
  color: #B3261E;
  border: 1px solid #F5C6C0;
}
</style>

<style>
/* Estilos del markdown renderizado (v-html, no puede ser scoped) */
.chat-msg .md-content > *:first-child { margin-top: 0; }
.chat-msg .md-content > *:last-child { margin-bottom: 0; }
.chat-msg .md-content p { margin: 0 0 8px; }
.chat-msg .md-heading { margin: 12px 0 6px; font-size: 16px; font-weight: 700; }
.chat-msg .md-list { margin: 0 0 8px; padding-left: 20px; list-style: disc; }
.chat-msg .md-list li { margin-bottom: 4px; }
.chat-msg .md-content code {
  background: rgba(29, 38, 45, 0.08);
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 13px;
}
.chat-msg .md-content a { color: #E45726; text-decoration: underline; overflow-wrap: anywhere; }
.chat-msg--user .md-content a { color: #fff; }
</style>
